///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { AfterViewInit, ChangeDetectorRef, Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';

import { GtthHistoryService } from '../../../project-view-panel/logical-topology/engine/history-service';
import { GtthBomReportService } from '../../../project-view-panel/project-windows/bom_report/bom-report.service';
import { ExtendedBomDeviceDTO } from '../../../project-view-panel/project-windows/bom_report/dto/extended-bom-device-dto.model';

export const ASSIGNED_NAME_PATTERN = '^[a-z0-9.-]{1,8}$';

export const ASSIGNED_NAME_DOES_NOT_MATCH_PATTERN_MESSAGE = `Required format is "${ASSIGNED_NAME_PATTERN}"`;
export const ASSIGNED_NAME_EXISTS_MESSAGE = 'Assigned name already exists';

export const assignedNameValidator = (
    device: ExtendedBomDeviceDTO,
    locationName: string,
    historyService: GtthHistoryService,
    bomReportService: GtthBomReportService
): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        const assignedName = control.value;

        if (!new RegExp(ASSIGNED_NAME_PATTERN).test(assignedName)) {
            return { error: ASSIGNED_NAME_DOES_NOT_MATCH_PATTERN_MESSAGE };
        }

        if (bomReportService.checkAssignedNameExists(locationName, device)) {
            return { warning: ASSIGNED_NAME_EXISTS_MESSAGE };
        }

        return null;
    };
};

@Directive({
    selector: '[windeAssignedNameValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: GtthAssignedNameValidatorDirective,
            multi: true
        }
    ],
    standalone: false
})
export class GtthAssignedNameValidatorDirective implements Validator, AfterViewInit {
    @Input() locationName: string;
    @Input() device: ExtendedBomDeviceDTO;

    constructor(
        private readonly changeDetector: ChangeDetectorRef,
        private readonly historyService: GtthHistoryService,
        private readonly bomReportService: GtthBomReportService
    ) {}

    ngAfterViewInit() {
        this.changeDetector.detectChanges();
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return assignedNameValidator(this.device, this.locationName, this.historyService, this.bomReportService)(control);
    }
}

// This directive should be used in AN and IP report where we just show values in read-only mode
@Directive({
    selector: '[windeAssignedNameViewValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: GtthAssignedNameViewValidatorDirective,
            multi: true
        }
    ],
    standalone: false
})
export class GtthAssignedNameViewValidatorDirective implements Validator {
    @Input() locationName: string;
    @Input() device: ExtendedBomDeviceDTO;

    constructor(
        private readonly historyService: GtthHistoryService,
        private readonly bomReportService: GtthBomReportService
    ) {}

    validate(control: AbstractControl): ValidationErrors | null {
        return assignedNameValidator(this.device, this.locationName, this.historyService, this.bomReportService)(control);
    }
}
